module.exports = __webpack_public_path__ + "img/1737127245559710.6fee0c48.jpg";